"use client";

import type { ButtonHTMLAttributes, Ref } from "react";

import { clsx } from "../../utils/clsx";
import { BaseButtonContent, type BaseButtonProps, buttonVariants } from "./base-button";

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "color">, BaseButtonProps {
  ref?: Ref<HTMLButtonElement>;
}

export const Button = ({
  className,
  variant = "fill",
  color = "contrast",
  size = "sm",
  disabled,
  loading,
  iconLeft,
  iconRight,
  ref,
  children,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={clsx(
        buttonVariants({
          variant,
          size,
          color: disabled ? "disabled" : color,
          className,
        }),
        !disabled && "cursor-pointer",
        disabled && "cursor-not-allowed",
      )}
      type="button"
      disabled={disabled}
      ref={ref}
      {...props}
    >
      <BaseButtonContent disabled={disabled} iconLeft={iconLeft} iconRight={iconRight} color={color} variant={variant} loading={loading}>
        {children}
      </BaseButtonContent>
    </button>
  );
};

Button.displayName = "Button";
